import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { IS_SUPER_ADMIN } from "../../../queries/super-admin-query";
import { useQuery } from "@apollo/react-hooks";
import AuthProvider from "../../../providers/Auth.Provider";

const ManagementMenu = ({ isSuperAdmin = false, path }) => {
    const [site, setSite] = useState(isSuperAdmin);

    const navigations = [
        {
            title: "Assessment",
            icon: "sticky-note",
            super: true,
            subs: [
                { link: "assessment/type-category", title: "Type & Category", icon: "tasks" },
                {
                    link: "assessment/question-option",
                    title: "Question & Option",
                    icon: "question-circle",
                },
            ],
        },
        {
            title: "Staffing",
            icon: "users",
            super: true,
            subs: [
                { link: "designation", title: "Designation", icon: "user-md" },
                {
                    link: "department",
                    title: "Department",
                    icon: "building",
                },
                {
                    link: "staff-type",
                    title: "Staff Type",
                    icon: "user-o",
                },
            ],
        },
        {
            title: "Leave",
            icon: "users",
            super: true,
            subs: [
                { link: "leave-type", title: "Leave Type", icon: "user-md" },
                {
                    link: "leave-status",
                    title: "Leave Status",
                    icon: "building",
                },
            ],
        },
        {
            title: "Advance",
            icon: "unlock",
            super: true,
            subs: [
                { link: "service-sub", title: "Service Subscription", icon: "user-md" },
                {
                    link: "activity-log",
                    title: "Activity Log",
                    icon: "building",
                },
                {
                    link: "note-category",
                    title: "Patient Activity",
                    icon: "building",
                },
                {
                    link: "super-admin",
                    title: "Super Administrator",
                    icon: "lock",
                },
                {
                    link: "site-type",
                    title: "Site Type",
                    icon: "lock",
                },
            ],
        },
    ];

    const { id } = AuthProvider.authProvider.GetToken() && AuthProvider.authProvider.GetAuthenticatedStaff();
    useQuery(IS_SUPER_ADMIN, {
        variables: {
            id,
        },
        onCompleted: (data) => {
            setSite(data.isSuperAdmin);
        },
    });

    return (
        <div className="menu-container">
            <nav className="navbar navbar-expand-lg navbar-light">
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#basicExampleNav"
                    aria-controls="basicExampleNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="basicExampleNav">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item">
                            <NavLink exact className="nav-link" to="/home/app-management">
                                <i className="fa fa-home"></i>
                                Overview
                            </NavLink>
                        </li>
                        {navigations.map((item, idx) => (
                            <React.Fragment key={idx}>
                                {item.super && site && (
                                    <li className="nav-item dropdown multi-level-dropdown">
                                        <a href="#" id="menu" data-toggle="dropdown" className="nav-link dropdown-toggle w-100">
                                            <i className={`fa fa-${item.icon}`}></i> {item.title} <i className="fa fa-angle-down"></i>
                                        </a>
                                        <ul className="dropdown-menu mr-2 rounded-0 primary-color border-0 z-depth-1 r-100">
                                            {item.subs.map((_sub, sidx) => (
                                                <li key={sidx} className="dropdown-item p-0">
                                                    <NavLink
                                                        className="w-100"
                                                        to={{
                                                            pathname: `${path}/${_sub.link}`,
                                                        }}
                                                    >
                                                        <i className={`fa fa-${_sub.icon}`}></i> {_sub.title}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                )}
                            </React.Fragment>
                        ))}
                        <li className="nav-item">
                            <NavLink exact className="nav-link" to="/home/app-management/duty-period">
                                <i className="fa fa-tasks"></i>
                                Rota Duty Period
                            </NavLink>
                        </li>
                        {site && (
                            <>
                                <li className="nav-item fade-in">
                                    <NavLink exact className="nav-link" to="/home/app-management/care-note-category">
                                        <i className="fa fa-sticky-note-o"></i>
                                        Care Note Category
                                    </NavLink>
                                </li>
                                <li className="nav-item fade-in">
                                    <NavLink exact className="nav-link" to="/home/app-management/parent-site">
                                        <i className="fa fa-hdd-o"></i>
                                        Parent Site
                                    </NavLink>
                                </li>
                            </>
                        )}
                        <li className="nav-item">
                            <NavLink exact className="nav-link" to="/home/app-management/patient-allergy">
                                <i className="fa fa-meh-o"></i>
                                Patient Allergies
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact className="nav-link" to="/home/app-management/ward">
                                <i className="fa fa-home"></i>
                                Ward Setting
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
};

export default ManagementMenu;
